import { render, staticRenderFns } from "./vipupgradetemplate.vue?vue&type=template&id=2660d800&scoped=true"
import script from "./vipupgradetemplate.vue?vue&type=script&lang=js"
export * from "./vipupgradetemplate.vue?vue&type=script&lang=js"
import style0 from "./vipupgradetemplate.vue?vue&type=style&index=0&id=2660d800&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660d800",
  null
  
)

export default component.exports